import classNames from "classnames";
import BackNavBar from "../../components/navBar/BackNavBar";
import style from "./DrugOverviewPage.module.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { mapDrugs } from "../../components/enhancedSearch/SearchResults/mapper/mapDrugs";
import { useDispatch, useSelector } from "react-redux";
import { drugSearchThunk, selectDrugSearchResults } from "../enhancedSearch";
import SearchResultItem from "../../components/enhancedSearch/SearchResults/SearchResultItem";
import { selectiDB, selectReferenceFiles } from "../counter/counterSlice";

const DrugOverviewPage = () => {
  const [searchParams] = useSearchParams();
  const drugName = searchParams.get('drug');
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const iDB = useSelector(selectiDB);
  const [pbsUrl, setPbsUrl] = useState("");
  const referenceFiles = useSelector(selectReferenceFiles);
  const drugSearchResults = useSelector(selectDrugSearchResults);

  useEffect(() => {
    if (drugName == undefined || !drugName) {
      navigate("/");
      return;
    }
    dispatch(
      drugSearchThunk({ searchText: drugName }),
    );
    iDB.read(referenceFiles.pbs_links).then((value) => {
      const pbsLinks = document.createElement('html');
      pbsLinks.innerHTML = value;
      setPbsUrl(Array.from(pbsLinks.querySelectorAll("xref")).find(link => link.innerHTML == drugName).attributes.href.value);
    });
  }, []);

  if (drugName == undefined || !drugName) {
    return <></>
  }

  let searchResults = mapDrugs(drugSearchResults);
  searchResults = searchResults.filter(result => result.title.toUpperCase() == drugName.toUpperCase());
  searchResults.sort((firstDrug, secondDrug) => firstDrug.summary.localeCompare(secondDrug.summary));

  return (
    <div>
      <BackNavBar></BackNavBar>
      <div className={classNames("size-14 bold", style.drugOverview)}>
        <div className={style.drugIconBackground}>
          <i
            className={classNames("tg-icons-Drug", style.drugIcon)}
          ></i>
        </div>
        <div className={classNames("size-36 medium")}>
          {drugName.charAt(0).toUpperCase() + drugName.slice(1)}
        </div>
        <a className={style.pbsButton} href={pbsUrl} target="_blank" data-testid="pbs_button">
          <div outputclass="drugcodes tgl_pbs"></div>
          <span className={style.pbsText}>Pharmaceutical Benefits Details</span>
          <i className={classNames("tg-icons-LeftArrow iconSize size-16", style.pbsArrow)}></i>
        </a>
        <div className={style.drugIndicationHeading}>
          <div>Drug indication</div>
          <div className={classNames("size-12 medium", style.drugCount)}>{searchResults.length}</div>
        </div>
        <ul className={style.resultList}>
          {(
            searchResults &&
            searchResults.length > 0 &&
            searchResults.map((result, index) => (
              <SearchResultItem
                isAppMode={true}
                searchResult={result}
                key={index}
                showBorder={false}
              />
            ))
          )}
        </ul>
      </div>
    </div>
  );
};

export default DrugOverviewPage;
